export const upload = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 15v6H3v-6M16.5 8 12 3 7.5 8M12 3.5v12" stroke="var(--theme-primary, #810ea9)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
